import * as memberManagement from '../services/memberManagement';

export default {
  namespace: 'ruleginDGM',

  state: {
    GraphList: [],
    addDiagramDate: null,
    getMemberList: null,
    addMember: null,
    versionList: null,
  },

  effects: {
    // 获取决策图列表
    *getGraphTable({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.getGraphTable,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          GraphList: response,
        },
      });
    },

    // 新增流程
    *addDiagram({ payload: { values }, callback }, { call, put }) {
      const { data: response = {} } = yield call(
        memberManagement.addDiagram,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          addDiagramDate: response,
        },
      });
    },

    // 编辑流程
    *editDiagram({ payload: { modelId, values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.editDiagram,
        modelId,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {},
      });
    },

    // 删除流程
    *deleteDiagram({ payload: { modelId, values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.deleteDiagram,
        modelId,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRule: response,
        },
      });
    },

    // 操作日志
    *getDiagramLog({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.getDiagramLog,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          diagramLogList: response,
        },
      });
    },

    // 查询版本list
    *getVersion({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        memberManagement.getVersion,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          versionList: response,
        },
      });
    },
    // 切换版本
    *changeVersion({ payload: { values }, callback }, { call }) {
      const response = yield call(memberManagement.changeVersion, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
